app.service('aoaService', function ($http) {


  this.loadAOAByCounty = function (obj) {
    return $http.post(`/aoaManagement/loadAOAByCounty`, obj)
      .then(function (response) {
        return response
      })
  }

  this.createFileByAPI = function (obj) {
    return $http.post(`/aoaManagement/createFileByAPI`, obj)
      .then(function (response) {
        return response
      })
  }

  this.updateDocumentRecords = function (obj) {
    return $http.post(`/aoaManagement/updateDocumentRecords`, obj)
      .then(function (response) {
        return response
      })
  }


})